import React from 'react';

import { RichText } from '../RichText/RichText';
import { PageTitle } from '../Layout/PageTitle';

import { CmsPageInnerProps } from './CmsPageInner';

export function CmsLayoutDefault(props: CmsPageInnerProps) {
    return (
        <>
            {props.content_heading && <PageTitle title={props.content_heading} />}
            <div>
                <RichText content={props.content} />
            </div>
        </>
    );
}
